<template>
  <div class="gst-details-main">
    <Input placeholder="New Comp Reg. No" :inputValue.sync="syncData['comRegNo']" :isDisabled="viewMode" :errorMessage.sync="syncData['comRegNoError']" ref="comregno" />
    <!-- <sup>Note: Please update 'Company Registration No' in 'General Details > Comp Reg No'.</sup> -->
    <DateTimePicker :value.sync="syncData['dateVerified']" :isDisabled="viewMode" :errorMessage.sync="syncData['dateVerifiedError']" />
    <Input placeholder="License No" :inputValue.sync="syncData['licenseNo']" :isDisabled="viewMode" :errorMessage.sync="syncData['licenseNoError']" ref="licenseno" />
    <Input placeholder="RMCD Approval No" :inputValue.sync="syncData['rmcdApprovalNo']" :isDisabled="viewMode" :errorMessage.sync="syncData['rmcdApprovalNoError']" ref="rmcdapprovalno" />
    <InputQuery placeholder="Default Tax Code" :items="syncData['taxCodeItems']" itemKey="Tax Code - Tax Code Desc" descKey="Tax Code" 
      :selectedObject.sync="syncData['selectedTaxCode']" :isDisabled="viewMode" />
    <InputQuery v-if="componentType === 'supplierTab' || componentType === 'creditorTab'" 
      placeholder="GST Major Industry Code" 
      :items="syncData['msicCodeItems']" 
      itemKey="MSIC Code" 
      descKey="Description"
      :selectedObject.sync="syncData['selectedMSICCode']" 
      :isDisabled="viewMode" 
      :allowFreeText="false" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function() {
    return {
      syncData: {
        comRegNo: '', comRegNoError: '',
        dateVerified: null,
        dateVerifiedError: '',
        licenseNo: '', licenseNoError: '',
        rmcdApprovalNo: '', rmcdApprovalNoError: '',
        taxCodeItems: [],
        selectedTaxCode: null,
        msicCodeItems: [],
        selectedMSICCode: null,
      }
    }
  },
  props: {
    viewMode: { type: Boolean, default: false },
    componentType: { type: String, default: '' },
    gstData: { type: Object, default: function() { return {
      comRegNo: '', comRegNoError: '',
      dateVerified: null,
      dateVerifiedError: '',
      licenseNo: '', licenseNoError: '',
      rmcdApprovalNo: '', rmcdApprovalNoError: '',
      taxCodeItems: [],
      selectedTaxCode: null,
      msicCodeItems: [],
      selectedMSICCode: null,
    } } },

    // Public Methods
    // focusGSTInput(val)
  },
  methods: {
    // Public Methods
    // val can be either 'licenseno' or 'rmcdapprovalno'
    focusGSTInput: function(val) {
      this.$refs[val].setFocus();
    }
  },
  mounted() {
    this.syncData = this.gstData;
  },
  watch: {
    syncData: {
      deep: true,
      handler: function(val) {
        this.$emit('update:gstData', val);
      }
    },
    gstData: {
      deep: true,
      handler: function(val) {
        this.syncData = val;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.date-verified {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>